export default __webpack_public_path__ + "static/media/21_3_0.d35a0beb.png";